import { connect } from 'react-redux';
import { StoreState } from '../../../reducers';

import CombinePanel from '../../../components/Editor/CombinePanel';
import Utils from '../../../utils';
import { Api } from '../../../typings/api';

interface CombinePanelContainerProps {
	importManagerId: string;
	isDisplayed: boolean;
}

const mapStateToProps = (state: StoreState, ownProps: CombinePanelContainerProps) => {
	const {
		importManager: { byId },
		selection,
		profile: { combineOptions },
	} = state;
	const { isDisplayed, importManagerId } = ownProps;

	return {
		isDisplayed,
		isImporting: !!byId[importManagerId],
		hasFromSelectionPicker: selection.resources.length > 0 && !Utils.isEmbedMode(),
		canSelectPublicationPages: [Api.CombineOption.ADVANCED, Api.CombineOption.MULTISELECT, Api.CombineOption.PLAYLIST].includes(combineOptions),
	};
};

export default connect(mapStateToProps)(CombinePanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/CombinePanel/index.tsx